import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { FacilityInput } from "generated-graphql/graphql";
import { transform } from "hooks/transform/transformFacility";
import { useCallback } from "react";
import { FacilityDetailsInput } from "routes/Customer/Facility/FacilityProfile";

export const VALIDATE_FACILITY_INPUT = gql(`
  query ValidateFacilityInput($id: ID!, $data: FacilityInput!, $reportId: ID, $omit: [String!], $pick: [String!]) {
    facilityInputValidator(id: $id, data: $data, reportId: $reportId, omit: $omit, pick: $pick) {
      ...issue
    }
  }
`);

export function useFacilityInputValidation({
  facilityId,
  reportId,
  omit,
  pick,
}: {
  facilityId: string;
  reportId: string | undefined;
  omit?: string[];
  pick?: string[];
}) {
  const [query] = useLazyQuery(VALIDATE_FACILITY_INPUT, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (input: FacilityDetailsInput) => {
      const inputToValidate: FacilityInput = transform(input);
      const { data } = await query({
        variables: {
          data: inputToValidate,
          id: facilityId,
          reportId,
          omit,
          pick,
        },
      });
      return data?.facilityInputValidator ?? [];
    },
    [facilityId, omit, pick, query, reportId]
  );
}
